"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSpinnerHiddenText = exports.StyledSpinner = exports.StyledWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
const rgba_1 = require("../../utils/rgba");
exports.StyledWrapper = styled_components_1.default.div `
    ${({ placement }) => {
    switch (placement) {
        case "inline":
            return "";
        default:
        case "center":
            return `
                    display: flex;
                    justify-content: center;
                `;
    }
}}
`;
exports.StyledSpinner = styled_components_1.default.div `
    ${({ dimension }) => {
    const spinnerDimension = {
        ["extra-small"]: tokens_1.SIZES[1.5],
        ["small"]: tokens_1.SIZES[3],
        ["medium"]: tokens_1.SIZES[6],
        ["large"]: tokens_1.SIZES[8],
    };
    return `
            height: ${spinnerDimension[dimension]};
            width: ${spinnerDimension[dimension]};
        `;
}}
    ${({ dimension }) => {
    const borderWidth = {
        ["extra-small"]: 2,
        ["small"]: 4,
        ["medium"]: 6,
        ["large"]: 8,
    };
    return `
            border-width: ${borderWidth[dimension]}px;
        `;
}}
    border-style: solid;
    border-radius: 50%;

    ${({ colour }) => {
    const spinnerColour = {
        ["white"]: tokens_1.COLOURS.greyscale.white,
        ["blue"]: tokens_1.COLOURS.primary.blue[100],
    };
    const spinnerSelectedColour = spinnerColour[colour];
    return `
            border-color: ${(0, rgba_1.rgba)(spinnerSelectedColour, 25)}; // adds 25% transparency on HEX color value
            border-top-color: ${spinnerSelectedColour};
        `;
}}

    animation: spin 0.75s ease-in-out infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
exports.StyledSpinnerHiddenText = styled_components_1.default.span `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;
//# sourceMappingURL=Spinner.styles.js.map